module.exports = __webpack_public_path__ + "static/media/instruction.a00a67f5.svg";